import guestAxios from "@/utils/guestAxios";

export const guestSurveyApi = {
  getActiveGuestSurvey: (params) => {
    return guestAxios.get("/api/Surveys/guest/active", {
      params,
      skipGuestAuthRedirect: true,
    });
  },

  submitSurvey: (surveyId, payload, params) => {
    return guestAxios.post(`/api/Surveys/${surveyId}/submit`, payload, {
      params,
      skipGuestAuthRedirect: Boolean(params?.sessionId || params?.guestSessionId),
    });
  },
};
